import Colors from 'assets/Colors';
import Lang from 'assets/Lang';
import React from 'react';
import AntDesign from 'react-native-vector-icons/AntDesign';
import Feather from 'react-native-vector-icons/Feather';
import UIConst from './UIConst';

const Status = {
  order: {
    pending: { id: 0, color: '#FF0000', text: Lang?.pending, icon: { type: Feather, name: 'clock' } },
    complete: { id: 1, color: '#FF0000', text: Lang?.complete, icon: { type: Feather, name: 'check-circle' } },
    canceled: { id: 2, color: '#FF0000', text: Lang?.canceled, icon: { type: AntDesign, name: 'closecircleo' } }
  },
  getStatusIcon: (icon, color = Colors.text, size = UIConst.SCALE * 16) => {
    const Icon = icon.type;
    return <Icon name={icon.name} size={size} color={Colors.text1} />;
  },
  getById: (id) => {
    Status.order.pending.color = '#F39C12';
    Status.order.complete.color = Colors.colorApp;
    if (id === 2) return Status.order.canceled;
    if (id === 1) return Status.order.complete;
    return Status.order.pending;
  },
  toArray: () => {
    const statusKeys = Object.keys(Status.order);
    let arr = statusKeys.map((e) => Status.order[e]);
    return arr;
  }
};
export default Status;
